module.exports = __webpack_public_path__ + "static/media/5.8bf4df23.jpg";